module.exports = __webpack_public_path__ + "assets/img/634e14368897ef44f8e4832cbd93fb2c.svg";